import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { RequireAuth, RequireAccess } from "@/components/RouteGuards";
import Layout from "@/components/Layout";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import RegisterCompanyPage from "@/pages/RegisterCompanyPage";
import DirectoryPage from "@/pages/DirectoryPage";
import CompanyProfilePage from "@/pages/CompanyProfilePage";
import UserDashboardPage from "@/pages/UserDashboardPage";
import CompanyDashboardPage from "@/pages/CompanyDashboardPage";
import PricingPage from "@/pages/PricingPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import PaymentCancelPage from "@/pages/PaymentCancelPage";
import MessagesPage from "@/pages/MessagesPage";
import ChatPage from "@/pages/ChatPage";
import LeadRequestPage from "@/pages/LeadRequestPage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/register-company" element={<RegisterCompanyPage />} />
            <Route path="/pricing" element={<RequireAuth><PricingPage /></RequireAuth>} />
            <Route path="/abonnement" element={<RequireAuth><PricingPage /></RequireAuth>} />
            <Route path="/directory" element={<DirectoryPage />} />
            <Route path="/company/:id" element={<CompanyProfilePage />} />
            <Route path="/dashboard" element={<RequireAccess><UserDashboardPage /></RequireAccess>} />
            <Route path="/company-dashboard" element={<RequireAuth><CompanyDashboardPage /></RequireAuth>} />
            <Route path="/payment-success" element={<RequireAuth><PaymentSuccessPage /></RequireAuth>} />
            <Route path="/payment/success" element={<RequireAuth><PaymentSuccessPage /></RequireAuth>} />
            <Route path="/payment/cancel" element={<PaymentCancelPage />} />
            <Route path="/messages" element={<RequireAccess><MessagesPage /></RequireAccess>} />
            <Route path="/chat/:convId" element={<RequireAccess><ChatPage /></RequireAccess>} />
            <Route path="/find-automatisk" element={<RequireAuth><LeadRequestPage /></RequireAuth>} />
          </Routes>
        </Layout>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
